import PainelAPI from '../../api/painel';

const state = {
  calendarState: { connected: false },
  calendars: [],
  uiFlags: { isFetching: false, isSyncing: false },
};

const getters = {
  getCalendarState: $state => $state.calendarState,
  getGoogleCalendars: $state => $state.calendars,
  getCalendarUiFlags: $state => $state.uiFlags,
  isSyncing: $state => $state.uiFlags.isSyncing,
};

const mutations = {
  SET_STATE($state, value) {
    $state.calendarState = value;
  },
  SET_CALENDARS($state, list) {
    $state.calendars = list;
  },
  SET_UI($state, { flag, value }) {
    $state.uiFlags = { ...$state.uiFlags, [flag]: value };
  },
};

const actions = {
  fetchState: async ({ commit }) => {
    const { data } = await PainelAPI.calendarState();
    commit('SET_STATE', data);
  },
  fetchCalendars: async ({ commit }) => {
    const { data } = await PainelAPI.listGoogleCalendars();
    commit('SET_CALENDARS', data.payload || []);
  },
  resync: async ({ commit, dispatch }) => {
    commit('SET_UI', { flag: 'isSyncing', value: true });
    await PainelAPI.resyncCalendar();
    setTimeout(async () => {
      await dispatch('fetchState');
      commit('SET_UI', { flag: 'isSyncing', value: false });
    }, 4000);
  },
  disconnect: async ({ dispatch }) => {
    await PainelAPI.disconnectCalendar();
    await dispatch('fetchState');
  },
};

export default { namespaced: true, state, getters, mutations, actions };
